import { styled } from "@mui/material";

interface ICustomTextFieldProps {
  value?: string;
  isErrorThere?: boolean;
  helpermessage?: boolean;
  texFieldSize?: string;
}

export const MuiStyledWrapper = styled("div")<ICustomTextFieldProps>(
  ({ theme, value, isErrorThere, texFieldSize }) => ({
    width: "100%",
    ".input-error": {
      color: theme.palette.error.main,
      marginTop: "3px !important",
      fontFamily: "Comfortaa-Regular",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "1px",
      textAlign: "left",
      // whiteSpace: "nowrap",
      fontSize: "1.2rem",

      // [theme.breakpoints.down('sm')]: {
      //   whiteSpace: "normal",
      //   overflow: "visible",
      //   textOverflow: "clip",
      // },
    },

    ".success-message": {
      color: theme.palette.success.main,
      fontFamily: "Comfortaa-Regular",
    },

    label: {
      color: isErrorThere ? theme.palette.error.main : theme.palette.grey[100],
      fontSize: "1.6rem",
      fontFamily: "Comfortaa-Regular",
      left: "13px !important",
      ":disabled": {
        color: isErrorThere
          ? theme.palette.error.main
          : theme.palette.grey[100],
      },
    },

    "& label.Mui-focused": {
      color: isErrorThere ? theme.palette.error.main : theme.palette.grey[300],
      fontFamily: "Comfortaa-Regular",
      fontSize: "1.6rem",
      left: "13px !important",
    },

    "&&& .MuiInputLabel-root.Mui-disabled": {
      color: isErrorThere ? theme.palette.error.main : theme.palette.grey[300],
      fontFamily: "Comfortaa-Regular",
      fontSize: "1.6rem",
      left: "13px !important",
    },

    "&& .MuiInputBase-input": {
      padding: texFieldSize ? "10px 8px!important" : "16px 8px!important",
    },

    ".MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: isErrorThere
        ? theme.palette.error.main
        : theme.palette.grey[200],
      color: isErrorThere ? theme.palette.error.main : theme.palette.grey[200],
      fontSize: "1.6rem",
      fontFamily: "Comfortaa-Regular",
    },

    "& .MuiInputBase-root.Mui-disabled": {
      "& > fieldset": {
        borderColor: "#576078",
      },
    },

    "& .MuiOutlinedInput-root": {
      color: isErrorThere
        ? theme.palette.error.main
        : theme.palette.common.white,
      fontSize: "1.6rem",
      fontFamily: "Comfortaa-Regular",
      padding: "0px 20px !important",
      "& fieldset": {
        borderRadius: "2.4rem",
        padding: "0 20px",
        borderColor: isErrorThere
          ? theme.palette.error.main
          : value
          ? theme.palette.grey[100] //theme.palette.secondary.main
          : theme.palette.grey[100],
      },
      "&:hover fieldset": {
        borderColor: isErrorThere
          ? theme.palette.error.main
          : theme.palette.secondary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: isErrorThere
          ? theme.palette.error.main
          : theme.palette.secondary.main,
      },
    },
  })
);
